/**
 *
 * Asynchronously loads the component for Booking
 *
 */

import loadable from 'loadable-components';

export default loadable(() => import('./index'));
